import { CustomButton, NAMESPACE, SvgReload, Tooltip } from '@ui-kit'
import { QueueRefreshButtonProps } from '../../types/queueConfig.types'

const QueueRefreshButton = ({
  className = '',
  disabled = false,
  isLoading = false,
  onRefresh,
  dataQaId,
}: QueueRefreshButtonProps) => {
  const isDisabled = disabled || isLoading

  return (
    <div className={`flex items-center text-center ${className}`}>
      <Tooltip
        content={NAMESPACE.REFRESH}
        position="bottom"
        cssClassName="flex items-center"
      >
        <CustomButton
          color="primary"
          className="border-none outline-none text-xs"
          dataQaId={dataQaId}
          disabled={isDisabled}
          aria-busy={isLoading}
          onClick={() => {
            if (!isDisabled && onRefresh) {
              onRefresh()
            }
          }}
        >
          <span className={isLoading ? 'animate-spin flex' : 'flex'}>
            <SvgReload />
          </span>
        </CustomButton>
      </Tooltip>
    </div>
  )
}

export default QueueRefreshButton
